<main role="main" class="">
  <div class="overlay"></div>
  <div class="container mt-3 mb-3">
    @if (userProfile$ | async; as userProfile) {
      <div class="card">

        <div class="card-header d-flex flex-row justify-content-between">
          <h2 class="shareholders-title">Shareholders</h2>

          <div>
            @if (userProfile.isAdmin) {
              <button class="ms-3 float-end btn btn-primary"
                      type="button"
                      (click)="showStocks()">
                Stock Pricing
              </button>
            }
          </div>

        </div>

        <div class="card-body">

          <div class='row mb-2'>
            <div class="col-sm-6 col-md-4 col-lg-4">

              <div class="input-group input-group-lg">
                <input id="filterInput" name="filterInput" type="text" class="form-control" placeholder="Search"
                       [value]="shareholderSearchFilter$|async" (input)="setSearchFilter($event.target.value)" maxlength="30">
              </div>

            </div>

            <div class='col-sm-6 col-md-8 col-lg-8'>
              <h5 class="mt-2 d-inline-block">
                {{hitMessage}}
              </h5>
              @if (userProfile.isAdmin) {
                <button class="shadow btn btn-site-primary float-end"
                        type="button"
                        (click)="createShareholder()">
                  <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg> Add New Shareholder
                </button>
              }
            </div>
          </div>

          <div class="row mb-4">
            <div class="col">

              <div class="ps-3">
                <div class="pretty p-svg p-curve p-pulse">
                  <input type="checkbox"
                         [(ngModel)]="includeRepurchaseOptionExecuted"
                         [ngModelOptions]="{standalone: true}"
                         (change)="setRepurchaseOptionAsOf($event.target.checked)" />
                  <div class="state p-success">
                    <svg class="svg svg-icon" viewBox="0 0 20 20">
                      <path d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z" style="stroke: white;fill:white;"></path>
                    </svg>
                    <label>Include Stock Lock Shareholders</label>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div [hidden]="!(filteredShareholders$ | async)?.length">
            <ngx-datatable id="shareholders-grid" class="material striped" [rows]="filteredShareholders$|async"
                           [columnMode]="ColumnMode.force" [rowHeight]="55" [headerHeight]="50" [footerHeight]="50" [limit]="15" [scrollbarV]="true">
              <!-- (sort)="onSort($event)"-->
              <!--[sorts]="sortOrder"
                  [scrollbarV]="true"
                    [rowHeight]="'auto'"
              (sort)="onLeadSort($event.sorts)"-->

              <!-- Preferred widths go on the column (not CSS !important) so ColumnMode.force can
                   still shrink/grow every column to fit the container. -->
              <ngx-datatable-column name="Shareholder" prop="displayName"
                                    [width]="250"
                                    headerClass="shareholderDisplay"
                                    cellClass="shareholderDisplay">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  @if (row.repurchaseOptionAsOf) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation text-error" viewBox="0 0 16 16">
                      <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L7.1 4.995z" />
                    </svg>
                  }
                  @if (userProfile.isAdmin || userProfile.isOfficer) {
                    <span class="text-underline text-site-primary-alt pointable"
                          [class.text-error]="row.repurchaseOptionAsOf"
                          (click)="editShareholder(row, $event)">
                      {{row.displayName}}
                    </span>
                  } @else {
                    <span>
                      {{row.displayName}}
                    </span>
                  }
                  <!--@if (row.repurchaseOptionAsOf) {
                  <i class="ps-2 fas fa-exclamation-triangle text-error"></i>
                  }-->
                </ng-template>
              </ngx-datatable-column>

              <!--<ngx-datatable-column name="Shareholder" prop="dealerDisplay" headerClass="shareholderDisplay"
                                    cellClass="shareholderDisplay">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <strong>{{row.info.displayName}}</strong><br />
                  <span class="ps-2">{{row.dealerContactSourceId}}</span><a href="mailto:{{row.dealerContactEmailAddress}}?subject=Adv4Dealers: {{row.dealerDisplay}} Merchandise Return"
                                                                            class="ps-2 text-site-primary"><i class="fa fa-envelope"></i></a>
                </ng-template>
              </ngx-datatable-column>-->

              <ngx-datatable-column name="Identification #" prop="pin" [width]="150" headerClass="identificationId"
                                    cellClass="identificationId">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <strong>*****{{row.pin}}</strong>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Offered" prop="totalAdjustedShareOffer" headerClass="offered"
                                    cellClass="offered">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.totalAdjustedShareOffer|number}}
                </ng-template>

              </ngx-datatable-column>

              <ngx-datatable-column name="Scheduled" prop="totalPurchasedShares" headerClass="scheduled"
                                    cellClass="scheduled">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.totalPurchasedShares|number}}
                </ng-template>

              </ngx-datatable-column>

              <ngx-datatable-column name="Evergreen" prop="totalEvergreenShares" headerClass="evergreen"
                                    cellClass="evergreen">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.totalEvergreenShares|number}}
                </ng-template>

              </ngx-datatable-column>

              <ngx-datatable-column name="Dividends" prop="totalDividendsAmountPaid" headerClass="dividends"
                                    cellClass="dividends">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.totalDividendsAmountPaid|currency}}
                </ng-template>

              </ngx-datatable-column>

              <!-- Report button column: fixed 50px, excluded from auto-resize so it is never squeezed
                   below the button's width on narrow containers. -->
              <ngx-datatable-column headerClass="custom" cellClass="custom" [width]="50" [minWidth]="50" [maxWidth]="50" [canAutoResize]="false">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <section class="text-center">
                    <button class="btn btn-sm btn-primary" type="button" (click)="viewReport(row)">
                      <i class="fa fa-search" style="font-size:12px;"></i>
                    </button>
                  </section>
                </ng-template>
              </ngx-datatable-column>


            </ngx-datatable>

          </div>

        </div>

      </div>
    }
  </div>
</main>

<ng-template app-confirm-simple>
  <app-confirm-modal-component></app-confirm-modal-component>
</ng-template>
